<template>
  <v-card>
    <v-card-title class="text-h5">
      Kohteen tietoja muokattu
    </v-card-title>
    <v-card-text class="pt-3 pb-0">
      <p>
        Kohteen tietoja on muokattu sopimuksen luonnin jälkeen.
        Siirry takaisin sopimuksen muokkaukseen päivittääksesi toimeksiannon ja selostusliitteen
        tiedot.
      </p>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn
        color="primary"
        text
        @click="goBack"
      >
        Siirry muokkaukseen
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>

export default {
  name: 'ChangesDetectedReturn',
  methods: {
    goBack() {
      this.$router.push({ name: 'commissionAgreement', params: this.$route.params });
    },
  },
};
</script>
